
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { Direction, directionToDegree } from '@/services/facetracker';

type IconType = 'arrow' | 'center' | 'not_found';
const getIconType = (dir: Direction): IconType => {
  switch (dir) {
    case Direction.Left:
    case Direction.Right:
    case Direction.Up:
    case Direction.Down:
      return 'arrow';
    case Direction.Center:
      return 'center';
    case Direction.None:
      return 'not_found';
  }
};

@Component({
  components: {}
})
export default class FaceDirectionArrow extends Vue {
  @Prop({ default: Direction.None })
  direction!: Direction;
  @Prop({ default: 0 })
  lookLevel!: number;

  private iconType: IconType = 'center';
  private iconRotation: number = 0;

  @Watch('direction')
  onDirectionChanged(value: Direction, oldValue: Direction) {
    this.iconType = getIconType(value);
    this.iconRotation = directionToDegree(value);
  }

  private get iconTransform() {
    const scale = this.lookLevel * 0.2;
    return `scale(${scale},${scale}) rotate(${this.iconRotation}deg)`;
  }
}
